import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { EventCodes } from '../../../../core/codes';
import { LoginCommon } from './login.common';
import { PageBase } from '../../../../core/page-base';
import { UserData } from '../../../../providers/user-data'; 
import { AppSettings } from '../../../../config/app-settings';
import { SignupPage } from '../signup/signup';
import { PageRef } from '../../../../core/core.module';
//import { RecipeData } from '../../../recipes/providers/recipe-data';


@Component({
	selector: 'page-login',
	templateUrl: 'login.html'
})

export class LoginPage extends PageBase{
	public login: {email?: string, password?: string} = {};
	public submitted = false;
	public formMsg: any;
	
	constructor(
		public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: LoginCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
    	//public recipeData: RecipeData,
    ) {	
    	super(settings, events, nav, userData);
		console.log("Loading Account Mobile");
	}

	ionViewDidEnter() {
		this.app.setTitle('Login');
	}

	ngAfterViewInit() {
		let self = this;
		self.events.subscribe(EventCodes.USER_LOGIN_ERROR, (err)=>{
			self.formMsg = err;
			this.cd.detectChanges();
		});	
	}

	public fbLogin(){
		this.common.fbLogin();
	}
	
	public googleLogin(){
		this.common.googleLogin();
	}
	
	public onLogin(form){
		this.common.onLogin(form, this.nav, this.login);
	}

	public openSignUp(){
		this.nav.push(SignupPage);		
	}
	public openForgotPassword(){
		this.nav.setRoot(this.pageRef.get('forgot-password'));
	}
	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/login/login.ts